import { Box, Stack } from '@mui/material';
import { Form, Formik } from 'formik';
import { type FC, useMemo } from 'react';

import {
    CountryLicenseFields,
    getPopulatedLicenseFormValues,
    toCountryLicenseFormValues,
} from './countryLicenseSelector';
import SubmitButton from 'components/common/formikForm/SubmitButton';

import useTranslate from 'hooks/useTranslate';
import type { ConsultantLicense, MyLicensesFormValues } from 'types';
import { myLicensesValidationSchema } from 'utils/validations/adminConsultants';

interface MyLicensesFormProps {
    licenses: ConsultantLicense[];
    onSubmit: (values: MyLicensesFormValues) => void | Promise<void>;
}

export const MyLicensesForm: FC<MyLicensesFormProps> = ({ licenses, onSubmit }) => {
    const { translate } = useTranslate();
    const validationSchema = useMemo(() => myLicensesValidationSchema(translate), [translate]);
    const initialValues = useMemo<MyLicensesFormValues>(
        () => ({
            licenses: toCountryLicenseFormValues(licenses),
        }),
        [licenses]
    );

    return (
        <Formik<MyLicensesFormValues>
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) =>
                onSubmit({
                    ...values,
                    licenses: getPopulatedLicenseFormValues(values.licenses),
                })
            }
        >
            {({ isSubmitting }) => (
                <Form>
                    <Stack spacing={2}>
                        <CountryLicenseFields />
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <SubmitButton loading={isSubmitting}>saveChanges</SubmitButton>
                        </Box>
                    </Stack>
                </Form>
            )}
        </Formik>
    );
};
